const Crypto = require('utils/Crypto');

const KEYS = {
    GPC: 'gpc',
    CCPA_CONSENT_COOKIE: 'ccpaConsentCookie',
    DEVICE_TYPE: 'device_type',
    IS_PREVIEW_ENV_COOKIE: 'preview',
    PREVIEW_COOKIE: 'previewdate',
    SESSIONID: 'JSESSIONID',
    RCPS_PRODUCT: 'rcps_product',
    SEPH_SESSION: 'SephSession',
    DYN_USER_ID: 'DYN_USER_ID',
    DYN_USER_CONFIRM: 'DYN_USER_CONFIRM',
    P13N_PRV: 'prv',
    RWD_BASKET: 'rcps_basket'
};

const writeCookieMillis = (name, value, millis = 0, onTopDomain = false, shouldEncode) => {
    var cookieStr = shouldEncode ? encodeURIComponent(name) + '=' + encodeURIComponent(value) : name + '=' + value;

    if (typeof document === 'undefined' && typeof global.document === 'undefined') {
        return;
    }

    if (millis !== 0) {
        var now = new Date();
        var then = new Date(now.getTime() + millis);
        var exp = then.toGMTString();
        cookieStr += '; expires=' + exp;
    }

    cookieStr += '; path=/';

    if (onTopDomain) {
        var dom;
        var parts;

        if (isNaN(parseInt(document.domain.replace(/\./g, '')))) {
            parts = document.domain.split('.');
            dom = parts.slice(-2).join('.');
        } else {
            dom = document.domain;
        }

        cookieStr += ';domain=' + dom;
    }

    document.cookie = cookieStr + ';SameSite=Lax';
};

const recalculateCookiesSize = () => {
    const { size } = new Blob([document.cookie]);
    digitalData.performance.cookiesSize = size;
};

const writeCookie = (name, value, days = 365, top, shouldEncode = true) => {
    writeCookieMillis(name, value, days * 86400000, top, shouldEncode);
    recalculateCookiesSize();
};

const deleteCookie = (key, top) => {
    writeCookieMillis(key, null, -1, top);
};

const readCookie = key => {
    if (typeof document === 'undefined' && typeof global.document === 'undefined') {
        return null;
    }

    const cookies = ('' + global.document.cookie).split('; ');

    for (let i = 0; i < cookies.length; ++i) {
        const currentCookie = cookies[i].split(/\=(.+)/).filter(Boolean);

        if (currentCookie.length !== 2) {
            /* eslint no-continue: 0 */
            continue;
        }

        const name = global.decodeURIComponent(currentCookie[0]);

        if (key === name) {
            return global.decodeURIComponent(currentCookie[1]);
        }
    }

    return null;
};

/**
 * GPC compliance in this case is reading a globalPrivacyControl from the navigator
 * and sync it with the gpc cookie. If flag turns to true - set a cookie, remove 1st party
 * cookies except allowed and reload the page
 * @returns {void}
 */
const complyGPC = () => {
    // Reaction to the GPC (https://jira.sephora.com/browse/UTS-2841)
    const userAgentGPCFlag = window.navigator.globalPrivacyControl || false;
    const gpcCookie = readCookie(KEYS.GPC);

    if (userAgentGPCFlag && gpcCookie !== '1') {
        const gpcUtils = require('utils/gpc');
        const locationUtils = require('utils/Location');

        gpcUtils.deleteAllCookiesExceptAllowed();
        writeCookie(KEYS.GPC, 1);

        locationUtils.reload();
    } else if (!userAgentGPCFlag && gpcCookie) {
        deleteCookie(KEYS.GPC);
    }
};

/**
 * SephSession is a cookie that will live in between user sessions.
 * The cookie also persists on all pages.
 * The cookie will live for 2 years.
 * @returns {void}
 */
const initializeSessionCookie = () => {
    if (readCookie(KEYS.CCPA_CONSENT_COOKIE) !== '1' && readCookie(KEYS.GPC) !== '1') {
        if (!readCookie('SephSession')) {
            const uuid = Crypto.createRandomUUID();
            writeCookie('SephSession', uuid, 730);
        }
    }
};

/**
 * Verifies if the CCPA or the GPC cookie enables the tracking of information.
 * True => Client doesn't allow tracking.
 * False => Client Allows tracking.
 * @returns {boolean}
 */
const isCCPAEnabled = () => {
    return readCookie(KEYS.CCPA_CONSENT_COOKIE) === '1' || readCookie(KEYS.GPC) === '1';
};

/**
 * Verifies if the rcps_product cookie enables the use of BXS Product api.
 * True => Will allow routing to new API.
 * False => Will use old API.
 * @returns {boolean}
 */
const isPXSEnabled = () => {
    return readCookie(KEYS.RCPS_PRODUCT) === 'true';
};

const isRWDBasketEnabled = () => {
    return readCookie(KEYS.RWD_BASKET) === 'true';
};

function initialize() {
    /* In future, if we want to depend only on Clarip for reading GPC signal, wrap complyGPC() in this condition - if (!Sephora.configurationSettings.isClaripPrivacyEnabled)
     */
    complyGPC();
    initializeSessionCookie();
}

module.exports = {
    KEYS,
    initialize,
    write: writeCookie,
    delete: deleteCookie,
    read: readCookie,
    recalculateCookiesSize,
    isCCPAEnabled,
    isPXSEnabled,
    isRWDBasketEnabled
};
